module.exports = "pegasus/assets/lp/charity/bg0.png";